export default {
  'guide.title1': '欢迎加入 OpenDataLab，',
  'guide.title2': '登录后你可以',
  'guide.desc1': '免费下载海量数据集',
  'guide.desc2': '创建上传管理数据集',
  'guide.desc3': '多元化开源标注工具',
  'guide.desc4': '实时反馈优化你的体验',
  'guide.login': '立即登录',
  'guide.register': '首次使用？{node}',
  'guide.register.node': '点我注册'
};
